import { message } from "antd";
import { useLanguage } from "../context/LanguageContext";
import messageTranslations from "../utils/messageContent";

const useNotificationsService = () => {
  const { language } = useLanguage();
  const t = messageTranslations[language] || messageTranslations["de"];

  const getUserNotifications = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/notifications/getNotificationsForUser`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(t.notifications?.loadError);
      }

      const data = await response.json();
      return data.notifications;
    } catch (error) {
      console.error("Load Notifications:", error.message);
      message.error(error.message);
      return null;
    }
  };

  // Hook anpassen
  const markNotificationsAsRead = async (not_id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/notifications/mark-as-read`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ notification_id: not_id }),
        }
      );

      if (!response.ok) {
        throw new Error(t.notifications?.markError);
      }

      const data = await response.json();
      // 👇 Keine message.success hier
      return data.notification;
    } catch (error) {
      console.error("Mark Notifications:", error.message);
      message.error(error.message);
      return null;
    }
  };

  return {
    getUserNotifications,
    markNotificationsAsRead,
  };
};

export default useNotificationsService;
